import type { PoliticalMatchCandidateMatch } from '@/models/political-match';
import type { GetPoliticalMatchesResponse } from '@/types/backend-contracts';

export function toPoliticalMatchCandidateMatches(response: GetPoliticalMatchesResponse): PoliticalMatchCandidateMatch[] {
  return response.candidates.map((candidate) => ({
    candidate: {
      id: candidate.candidate.id,
      slug: candidate.candidate.slug,
      name: candidate.candidate.name,
      party: candidate.candidate.party,
      number: candidate.candidate.number,
      imageUrl: candidate.candidate.imageUrl,
    },
    position: {
      economicScore: candidate.position.economicScore,
      personalScore: candidate.position.personalScore,
      alignmentLabel: candidate.position.alignmentLabel,
      answeredQuestions: candidate.position.answeredQuestions,
      totalQuestions: candidate.position.totalQuestions,
    },
    answers: candidate.answers.map((answer) => ({
      id: answer.id,
      candidateId: answer.candidateId,
      questionId: answer.questionId,
      questionnaireVersion: answer.questionnaireVersion,
      stance: answer.stance,
      reasoning: answer.reasoning,
      confidence: answer.confidence,
      evidence: answer.evidence,
      summary: answer.summary,
      reviewed: answer.reviewed,
      createdAt: answer.createdAt?.toDate?.().toISOString(),
      updatedAt: answer.updatedAt?.toDate?.().toISOString(),
    })),
  }));
}
